import styled from "styled-components";
import { spacings } from "../../../../assets/themes";
import { FormControl } from "../../../../components";

const StyledFormControl = styled(FormControl)`
  margin-top: ${spacings.ml};
`;

export default StyledFormControl;
